import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import ResultsTable from './ScreeningHistory/ResultsTable';

const ScreeningHistoryModal = (props) => {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName="modal3"
            centered
            animation={false}
        >
            <div className={'modal-content-white'}>
                <Modal.Body
                    className='table-exams-content'
                >
                    <Table striped className='table-exams'>
                        <thead>
                            <tr>
                                <th>Exámen</th>
                                <th>Resultado anterior</th>
                                <th>Resultado</th>
                                <th>Valor referencia</th>
                                <th>Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ResultsTable
                                examsObj={props.examsObj}
                            />
                        </tbody>
                    </Table>
                </Modal.Body>
            </div>

        </Modal>
    );
}

export default ScreeningHistoryModal;